import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { EngagementModels } from '../components/EngagementModels';
import { ContactSection } from '../components/ContactSection';
export function ContactPage() {
  return <>
      <PageHeader label="Contact" title="Board opportunities and executive consultation" description="Direct contact details, a downloadable CV, and an inquiry form routed straight to Kevin." data-id="element-457" data-mp="sqsw3fpatnq3" />
      <EngagementModels data-id="element-458" data-mp="11g12a4jm26p" />
      <ContactSection data-id="element-459" data-mp="50f0jf7i96qr" />
    </>;
}